import { useTranslation } from 'react-i18next'

import { useLinkLikeClick } from '../../../../../hooks'
import { stopPropagation } from '../../../../../utils/events'
import { AVATAR_HEIGHT_32 } from '../../../../Avatar'
import { UserListItem } from '../../../../ListItem'
import {
  getApplicantProfileLink,
  getIsRentalPortalApplicantIdentityMasked,
  getRentalPortalApplicantIdentityLabel,
} from '../../../../RentalPortalApplicant'
import { toViewingApplicantIdentity } from '../../../../RentalPortalViewing'
import { toViewingProfileApplicantValue } from '../../RentalPortalViewingProfile.utils'
import { QA_NAME_VIEWING_APPLICANTS_DELETE_BTN } from '../RentalPortalViewingProfileWidgetApplicants.constants'
import { ViewingApplicantsItemIcons } from '../ViewingApplicantsItemIcons'

import { isViewingApplicantDeleting } from './ViewingApplicantsItem.utils'

import * as styles from './ViewingApplicantsItem.module.css'

import LockIcon from '../../../../../icons/lock.svg'

function ViewingApplicantsItem({
  canDelete,
  deletingApplicantId,
  value,
  onDelete,
}) {
  const { t } = useTranslation()

  const { handleClick } = useLinkLikeClick()

  const isDeleting = isViewingApplicantDeleting({
    applicant: value,
    deletingApplicantId,
  })

  const identity = toViewingApplicantIdentity(value)

  const isMasked = getIsRentalPortalApplicantIdentityMasked(identity)

  const isClickable = value.can_view && !isMasked

  function handleClickApplicant() {
    handleClick({ link: getApplicantProfileLink(value.id) })
  }

  function handleDelete(event) {
    stopPropagation(event)

    onDelete(value.id)
  }

  function handleNeedToShowIcons({ isHovered }) {
    return isDeleting || isHovered
  }

  return (
    <UserListItem
      AdditionalInfo={null}
      Icon={isMasked ? LockIcon : null}
      Icons={ViewingApplicantsItemIcons}
      avatarSize={AVATAR_HEIGHT_32}
      blocked={!isClickable}
      className={styles.ViewingApplicantsItem}
      hoverClassName={styles.hover}
      iconsProps={{
        canDelete: canDelete && !value.is_primary,
        deleteButtonQaName: QA_NAME_VIEWING_APPLICANTS_DELETE_BTN,
        isDeleting,
        isDisabled: Boolean(deletingApplicantId),
        lockedTooltip: value.is_primary
          ? t('RentalPortal.ViewingApplicantsPrimaryLockedTooltipKey')
          : null,
        onDelete: handleDelete,
      }}
      isNeedToShowIcons={handleNeedToShowIcons}
      tooltipAdditionalText={
        isClickable ? t('Common.ClickToOpenProfileKey') : null
      }
      value={toViewingProfileApplicantValue({
        applicant: value,
        label: getRentalPortalApplicantIdentityLabel({
          applicant: identity,
          t,
        }),
      })}
      onClick={handleClickApplicant}
    />
  )
}

export default ViewingApplicantsItem
